'use strict';

/**
 * @author Maxim Seredkin
 * @param {*} $scope
 * @param {*} $rootScope
 */
export default ['$scope', '$rootScope', 'StaffService', '$window', 'ReportsRestService', '$log', '$timeout',
                function($scope, $rootScope, StaffService, $window, ReportsRestService, $log, $timeout) {
                    $rootScope.title = 'Отчет "События по проекту"';

                    $scope.dateFormat = null;
                    $scope.form = {};
                    $scope.projectManagers = [];

                    $scope.startDateInput = {};
                    $scope.endDateInput = {};

                    init();

                    /**
                     * Инициализация
                     */
                    function init() {
                        $scope.dateFormat = 'dd.MM.yyyy';
                        $scope.form = {
                            staffs: [],
                            startDate: new Date(),
                            endDate: new Date(),
                        };
                        $scope.startDateInput = {
                            opened: false,
                        };

                        $scope.endDateInput = {
                            opened: false,
                        };

                        StaffService.api.getAvailableProjectManagersOfCurrentUser({}, (data) => {
                            $scope.projectManagers = data.items;
                        });
                    }

                    $scope.generate = () => {
                        ReportsRestService.get({
                                                   managerIds: $scope.form.staffs.map((staff) => staff.id),
                                                   startDate: $scope.form.startDate.toISOString(),
                                                   endDate: $scope.form.endDate.toISOString(),
                                               },
                                               (data) => _download(data));
                    };

                    $scope.isInvalid = () => {
                        return $scope.form.staffs.length <= 0
                               || $scope.form.startDate == null
                               || $scope.form.endDate == null;
                    };

                    /**
                     * Download file.
                     *
                     * @param res
                     * @param fileName
                     * @private
                     */
                    function _download(res, fileName) {
                        // TODO: убрать эту ересь
                        let blob = new Blob([res.data], {type: res.contentType});
                        let url = $window.URL.createObjectURL(blob);
                        let a = $window.document.createElement('a');

                        // Получение имени файла с расширением из заголовков Content-Type и Content-Disposition
                        let fileNameFromResponse = decodeURI(res.contentDisposition.split('\'').pop());

                        $window.document.body.appendChild(a);
                        a.style = 'display: none';
                        $timeout(() => {
                            a.href = url;
                            /**
                             * Если filename был жестко задан, то оставляем такое имя файла,
                             * если filename === null, то берем имя файла из ответа API
                             */
                            a.download = (fileName) ? fileName : fileNameFromResponse;
                            a.click();
                        }, 0);
                    }
                }];
